exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  min-height: 100vh;\n  background: #eef4f8;\n  color: #142234;\n  font-family: Arial, Helvetica, sans-serif;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /storage/data/github/tests/angular-data-table-component/angular-4/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/storage/data/github/tests/angular-data-table-component/angular-4/node_modules/postcss-loader?{"ident":"postcss"}!/storage/data/github/tests/angular-data-table-component/angular-4/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles